import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import SVG from "react-inlinesvg";
import classNames from "classnames";

//images
import headerImg from "../../../../assets/images/redesign/signup-react/pinchme_logo.svg";

function Header({ menuHandler }) {
  const [width, setWidth] = useState(window.innerWidth);
  const isMobile = width <= 768;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const headerClassNames = classNames(["pw-header", { open: isMenuOpen }]);

  // Set menu classsed according to screen width
  useEffect(() => {
    window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
  }, [window, width]);

  const listItemClasses = useCallback(() => {
    if (!isMobile) {
      return "";
    }

    let classes;

    if (isMenuOpen) {
      classes = "pw-fadeIn pw-fadein-list";
    } else {
      classes = "pw-fadeOut pw-fadeout-list";
    }

    return classes;
  }, [width, isMenuOpen]);

  const handleClick = state => {
    setIsMenuOpen(false);
    menuHandler(state);
  };

  return (
    <div className="header-top-navigation">
      <header className={headerClassNames}>
        <div className="pw-header--inner-container">
          <div className="header">
            <SVG
              width={155}
              height={35}
              className="pw-header-logo"
              src={headerImg}
            />
            <span
              className={classNames(["menu-btn", { "menu-open": isMenuOpen }])}
              id="menu-btn"
            />
            <label className="menu-icon" htmlFor="menu-btn">
              <span
                onClick={() => setIsMenuOpen(state => !state)}
                className="navicon"
              />
            </label>
            <ul
              id="navbar"
              className={classNames([
                "menu",
                {
                  "pw-maxHeight": isMobile && isMenuOpen,
                  "pw-minHeight": isMobile && !isMenuOpen
                }
              ])}
            >
              {isMobile && (
                <li
                  onClick={() => handleClick(true)}
                  className={listItemClasses()}
                >
                  <a className="pw-login-btn pw-padding-top">Log In</a>
                </li>
              )}
              {isMobile && (
                <li
                  onClick={() => handleClick(false)}
                  className={listItemClasses()}
                >
                  <a className="pw-login-btn">Sign Up</a>
                </li>
              )}

              <li className={listItemClasses()}>
                <a href="https://blog.pinchme.com">Blog</a>
              </li>
              <li className={listItemClasses()}>
                <a href="how_it_works">How It Works</a>
              </li>
              <li className={listItemClasses()}>
                <a href="our_samples">Our Samples</a>
              </li>
              <li className={listItemClasses()}>
                <a href="partners">Partners</a>
              </li>
              <li className={listItemClasses()}>
                <a href="https://investors.pinchme.com">Investors</a>
              </li>
              {!isMobile && (
                <li onClick={() => handleClick(true)}>
                  <a className="pw-login-btn">Log In</a>
                </li>
              )}
              {isMobile && (
                <li
                  onClick={() => handleClick(false)}
                  className={listItemClasses()}
                >
                  <a href={"about_us"}>About Us</a>
                </li>
              )}
              {isMobile && (
                <li
                  className={listItemClasses()}
                  style={{ borderBottom: "none" }}
                  onClick={() => handleClick(false)}
                >
                  <a
                    className={"pw-padding-bottom"}
                    href="https://helpcenter.pinchme.com"
                  >
                    Help Center
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Header;

Header.propTypes = {
  menuHandler: PropTypes.func
};
